/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Période de filtre — DATES CALENDAIRES : envoyer "yyyy-MM-dd" sec, sans heure ni offset (contrat back « Dates & fuseaux »). Jamais d'objet Date sérialisé en ISO UTC (décale d'un jour selon le fuseau).
 * 
 * @export
 * @interface FilterPeriodDto
 */
export interface FilterPeriodDto {
    /**
     * Date calendaire "yyyy-MM-dd"
     * @type {string}
     * @memberof FilterPeriodDto
     */
    startDate?: string | null;
    /**
     * Date calendaire "yyyy-MM-dd"
     * @type {string}
     * @memberof FilterPeriodDto
     */
    endDate?: string | null;
}

/**
 * Check if a given object implements the FilterPeriodDto interface.
 */
export function instanceOfFilterPeriodDto(value: object): value is FilterPeriodDto {
    return true;
}

export function FilterPeriodDtoFromJSON(json: any): FilterPeriodDto {
    return FilterPeriodDtoFromJSONTyped(json, false);
}

export function FilterPeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterPeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}

export function FilterPeriodDtoToJSON(json: any): FilterPeriodDto {
    return FilterPeriodDtoToJSONTyped(json, false);
}

export function FilterPeriodDtoToJSONTyped(value?: FilterPeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

